import { HttpErrorResponse } from '@angular/common/http';
import { INameId } from '@modeso/types__aumico-lib-core-be';
import { ILegalFormExtendedDTO } from '@modeso/types__aumico-lib-settings-be';
import { Subject } from 'rxjs';

export interface ILegalformFormData {
    legalForm: ILegalFormExtendedDTO | undefined;
    errorMessage: Subject<HttpErrorResponse>;
    countries: INameId[];
}
